import LegalLayout from '../components/LegalLayout';
import { COMPANY, HOSTING, SELLER_ID, LEGAL_UPDATED_TERMS } from '../constants/legal';

const LegalNoticePage = () => (
  <LegalLayout
    testId="legal-notice-page"
    title="Legal Notice — Mentions Légales"
    description="Mentions légales — NPDS, Gate 33. Company information, SIREN, SIRET, VAT, publication director, hosting provider."
    path="/legal/mentions-legales"
    updated={LEGAL_UPDATED_TERMS}
  >
    <p className="text-lg text-[#1A1A1A] leading-relaxed mb-8">
      In accordance with Article 6 of the French LCEN law (Law No. 2004-575 of 21 June 2004 for confidence in the digital economy), the following information is made available to visitors of gate33.co.
    </p>

    <h2>1. Publisher (Éditeur du site)</h2>
    <p data-testid="legal-publisher">
      {SELLER_ID} Email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
    </p>

    <h2>2. Publication director (Directeur de la publication)</h2>
    <p>{COMPANY.publicationDirector}</p>

    <h2>3. Hosting provider (Hébergeur)</h2>
    <ul>
      <li><strong>Name:</strong> {HOSTING.name}</li>
      <li><strong>Website:</strong> <a href={HOSTING.website} target="_blank" rel="noopener noreferrer">{HOSTING.website}</a></li>
      <li><strong>Address:</strong> {HOSTING.address}</li>
      <li><strong>Phone:</strong> {HOSTING.phone}</li>
    </ul>

    <h2>4. Intellectual property</h2>
    <p>
      All content published on this website (text, images, illustrations, structure, source code, downloadable materials) is the exclusive property of {COMPANY.legalName} unless expressly stated otherwise. Any reproduction, representation, modification, publication or full or partial adaptation, whatever the means or process, is prohibited without the prior written authorization of {COMPANY.legalName}. Any unauthorized use of the site or any of its contents will be considered an infringement and subject to the provisions of Articles L.335-2 and following of the French Intellectual Property Code.
    </p>

    <h2>5. Trademarks</h2>
    <p>
      The name "Gate 33" and the associated logo are used in commerce by {COMPANY.legalName}. Any unauthorized reproduction of these trademarks or distinctive signs constitutes an infringement.
    </p>

    <h2>6. Liability</h2>
    <p>
      {COMPANY.tradingName} publishes editorial and training content in good faith. The information provided on this website is for general information and educational purposes only. Salary ranges, contract terms, roster patterns, market data and operator descriptions reflect information available at the date of publication and are not commitments or guarantees regarding any specific operator. {COMPANY.legalName} shall not be held liable for any decision made on the sole basis of information published on gate33.co.
    </p>

    <h2>7. External links</h2>
    <p>
      Gate 33 may contain links to third-party websites (Stripe, PayPal, HubSpot, LinkedIn, Calendly, etc.). {COMPANY.legalName} has no control over these websites and disclaims any responsibility for their content and privacy practices.
    </p>

    <h2>8. Applicable law and jurisdiction</h2>
    <p>
      This legal notice is governed by {COMPANY.governingLaw}. Any dispute related to the use of gate33.co, in the absence of an amicable resolution, falls within the exclusive jurisdiction of the {COMPANY.jurisdiction}.
    </p>
  </LegalLayout>
);

export default LegalNoticePage;
